import request from "./../utils/request";
import axios from "axios";
import { getChannelId } from "./../utils/channel";

const socketRequest = axios.create({
    baseURL: process.env.SOCKET_URL,
    timeout: 20000,
});

// fresh: ayar degisti bildirimi sonrasi CDN ve sunucu onbellegini atlar
export function getSettings(fresh = false) {
    const channelId = getChannelId();
    const extra = (channelId ? "&channel=" + channelId : "") + (fresh ? "&t=" + Date.now() : "");
    return request.get(`/public/settings/get-all?contain=trigger,all,liveAnalytics${extra}`);
}

export function getCountryPhoneInfos() {
    return socketRequest.get(`/phone-infos-country`).then((res) => res.data);
}



// WEBPACK FOOTER //
// ./src/api/setting.js